// extracted by mini-css-extract-plugin
export var container = "quantitySelector-module--container--dm54n";
export var quantityInput = "quantitySelector-module--quantity-input--uTibc";
export var selector = "quantitySelector-module--selector--ifeH9";